import React from 'react'

export default class OutState extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {
    this.props.onChangeCallback(e.target.checked)
  }

  render() {

    let pretn = this.props.pretn

    let inputValue = typeof pretn.is_igst !== "undefined" ? pretn.is_igst : false

    let check = <div> <input type="checkbox" checked={inputValue} onChange={this.handleChange} /></div>

    return <div>{check}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/debit/rowelements/outstate.js